// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2800":"d468f2b77ae9f809","4656":"b834cb3e78315836","8027":"6fb70edd9fa3d1de"}[chunkId] + ".css";
};